import { customFetch } from "../../utils/Auth";
import { environment } from "../../config/environment";

const API = environment.apiUrl;
const base = `${API}/foia`;

// customFetch only throws on network/auth failures, so preserve status + body
// here for callers to distinguish 403/404/409/etc. from a generic failure.
const request = async (path, options) => {
  const res = await customFetch(`${base}${path}`, options);
  let body = null;
  try {
    body = await res.json();
  } catch {
    // non-JSON body, leave null
  }
  if (!res.ok) {
    const err = new Error(body?.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body;
};

export const fetchFoiaRequests = ({ q, status, assignee, dueBefore } = {}) => {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (status) params.set("status", status);
  if (assignee) params.set("assignee", assignee);
  if (dueBefore) params.set("due_before", dueBefore);
  const qs = params.toString();
  return request(`/requests${qs ? `?${qs}` : ""}`);
};

export const fetchFoiaRequest = (requestId) => request(`/requests/${requestId}`);

export const parseFoiaEmail = (rawText) => request(`/parse-email`, { method: "POST", body: JSON.stringify({ rawText }) });

export const searchFoiaPatients = ({ name, appointments = [], stationId = "" }) => {
  const params = new URLSearchParams({ q: name });
  appointments.forEach(({ date, provider }) => {
    params.append("date", date || "");
    params.append("provider", provider || "");
  });
  if (stationId) params.set("station", stationId);
  return request(`/patients/search?${params.toString()}`);
};

export const fetchFoiaPatientAppointments = (mrn) => request(`/patients/${encodeURIComponent(mrn)}/appointments`);

export const createFoiaRequest = (payload) => request(`/requests`, { method: "POST", body: JSON.stringify(payload) });

export const fetchFoiaTasks = ({ assignee, q } = {}) => {
  const params = new URLSearchParams();
  if (assignee) params.set("assignee", assignee);
  if (q) params.set("q", q);
  const qs = params.toString();
  return request(`/tasks${qs ? `?${qs}` : ""}`);
};

export const postFoiaAction = (requestId, { actionCode, flow, appointmentRecordId, metadata, idempotencyKey }) =>
  request(`/requests/${requestId}/actions`, {
    method: "POST",
    body: JSON.stringify({ actionCode, flow, appointmentRecordId, metadata, idempotencyKey }),
  });
